import React, { useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import { useParams } from 'react-router-dom';
import HttpClient from '../../utils/HttpClient';
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment';

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const headLineStyle1 = {
    textAlign: "left",
    fontSize: "20px",
    color: "indigo",
    margin: "10px",
    // fontWeight: "bold"


}
const customStyles = {
    rows: {
        style: {
            minHeight: '28px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const PartnerPurchaseDetails = () => {
    const params = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const [OfferviewData, setOfferviewData] = useState([]);
    const [OfferPurchaseData, setOfferPurchaseData] = useState([]);
    const [OfferIssueData, setOfferIssueData] = useState([]);
    const [partnerData, setPartnerData] = useState({});


    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "3.4rem"
        },
        {
            name: 'Name',
            selector: row => row.userName,
            width: "13.4rem"
        },
        {
            name: 'Offer View Date & time',
            selector: row => row.createdOn,
            width: "13.4rem"
        },


    ];
    const columns1 = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "3.4rem"
        },
        {
            name: 'Name',
            selector: row => row.userName,
            width: "13.4rem"
        },
        {
            name: 'Offer Redeem Date & time',
            selector: row => row.voucherRedeemDate,
            width: "13.4rem"
        },


    ];
    const columns2 = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "3.4rem"
        },
        {
            name: 'Name',
            selector: row => row.userName,
            width: "13.4rem"
        },
        {
            name: 'Offer Issued Date & time',
            selector: row => row.voucherRedeemDate,
            width: "13.4rem"
        },


    ];


    const purchasDetails = async () => {
        setIsLoading(true)
        const data = {
            "partnerId": params?.id
        }
        let offerView = [];
        let offerPurchase = [];
        let offerIsueOnly = [];
        let partnerDetails = {};

        const res = await HttpClient.requestData("partner-offers-details", "POST", data)
        if (res && res?.status) {
            setIsLoading(false);
            offerView = res?.data?.[0]?.OfferView?.map((item, i) => ({
                sl: i + 1,
                id: item?._id,
                userName: item?.userName,
                createdOn: moment(item?.createdOn).format("DD/MM/YYYY HH:mm A"),
            }))





            offerPurchase = res?.data?.[0]?.OfferPurchase?.filter((item) => item?.voucherReedem)?.map((item, i) => ({
                sl: i + 1,
                id: item?._id,
                userName: item?.UserName,
                voucherRedeemDate: moment(item?.voucherRedeemDate).format("DD/MM/YYYY HH:mm A"),
            }))
            offerIsueOnly = res?.data?.[0]?.OfferPurchase?.filter((item) => !item?.voucherReedem)?.map((item, i) => ({
                sl: i + 1,
                id: item?._id,
                userName: item?.UserName,
                voucherRedeemDate: moment(item?.voucherRedeemDate).format("DD/MM/YYYY HH:mm A"),
            }))
            partnerDetails = {
                name: res?.data?.[0]?.partnerName, offerType: res?.data?.[0]?.offerType,
            }

        }
        else {
            setIsLoading(false);
        }
        setOfferviewData(offerView)
        setOfferPurchaseData(offerPurchase);
        setPartnerData(partnerDetails)
        setOfferIssueData(offerIsueOnly)
    }

    useEffect(() => {
        if (params?.id) {
            purchasDetails()
        }

    }, [params?.id])


    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        VIEW OFFER DETAILS OF  ~ <span className='text-danger border-bottom border-4 border-danger '>{partnerData?.name?.toUpperCase()}</span>
                    </div>


                    <div className="d-flex justify-content-around mt-5">
                        <form>
                            <h5 className="d-flex justify-content-center mb-2 text-primary ">OFFER VIEW DETAILS</h5><hr />
                            <div className=" border rounded border-primary " style={{ width: "485px" }}>

                                <DataTable
                                    columns={columns}
                                    data={OfferviewData}
                                    pagination
                                    striped
                                    className=" rounded "
                                    customStyles={customStyles}
                                />
                            </div>

                        </form>
                        <form>
                            <h5 className="d-flex justify-content-center mb-2 text-success ">OFFER REDEEMED DETAILS</h5><hr />
                            <div className=" border rounded border-success " style={{ width: "485px" }}>

                                <DataTable
                                    columns={columns1}
                                    data={OfferPurchaseData}
                                    pagination
                                    striped
                                    className=" rounded "
                                    customStyles={customStyles}
                                />
                            </div>

                        </form>
                      
                    </div>
                    <div className="d-flex justify-content-start mt-3 mx-4">
                       
                        <form>
                            <h5 className="d-flex mb-2 justify-content-center text-indigo ">OFFER ISSUED DETAILS</h5><hr />
                            <div className=" border rounded border-indigo " style={{ width: "485px" }}>

                                <DataTable
                                    columns={columns2}
                                    data={OfferIssueData}
                                    pagination
                                    striped
                                    className=" rounded "
                                    customStyles={customStyles}
                                />
                            </div>

                        </form>
                      
                    </div>
                </section>


            </div>

        </div>
    )
}

export default PartnerPurchaseDetails